import { useEffect } from 'react'
import { useEconomyStore } from '@/state/useEconomyStore'
import { useUIStore } from '@/state/useUIStore'
import { getWallet, registerPlayer } from '@/economy/api'
import './GameHUD.css'

export function GameHUD() {
  const setWallet = useEconomyStore((s) => s.setWallet)
  const openSettings = useUIStore((s) => s.openSettings)
  const loadProgress = useUIStore((s) => s.loadProgress)

  // Fetch wallet on mount
  useEffect(() => {
    if (loadProgress < 100) return
    async function load() {
      try {
        const w = await getWallet()
        setWallet(w)
      } catch {
        try {
          const w = await registerPlayer()
          setWallet(w)
        } catch { /* not logged in */ }
      }
    }
    load()
  }, [loadProgress, setWallet])

  // I key toggles inventory
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key.toLowerCase() === 'i') {
        const ui = useUIStore.getState()
        const econ = useEconomyStore.getState()
        // Don't open inventory if a building panel is open
        if (econ.panelOpen) return
        if (ui.showInventory) {
          ui.closeInventory()
        } else {
          ui.openInventory()
        }
      }
    }
    window.addEventListener('keydown', handleKey)
    return () => window.removeEventListener('keydown', handleKey)
  }, [])

  if (loadProgress < 100) return null

  return (
    <>
      {/* Top-right: Settings button */}
      <div className="game-hud__actions">
        <button className="game-hud__btn" onClick={openSettings} title="Settings">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3" />
            <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
          </svg>
        </button>
      </div>
    </>
  )
}
